import React from "react";

const EditPatient = () => {
  return (
    <div>
      <h4>Edit Patient</h4>
      <p>Form to update patient information will go here.</p>
    </div>
  );
};

export default EditPatient;
